class ProductExclusive extends HTMLElement {
  constructor () {
    super()

    this.input = window.BAO.utils.getElement('.prd-Exclusive_Input')
    this.list = window.BAO.utils.getElement('.prd-Exclusive_Items')
    this.submitButton = window.BAO.utils.getElement('.prd-Exclusive_Submit')

    this.input.addEventListener('input', this.onInputType.bind(this))
  }

  onInputType = ({ target }) => {
    const validInputLength = target.value.length > 0

    this.list.innerHTML = ''
    if (target.value) {
      this.createHiddenInput(
        `${this.dataset.label}`,
        `RCC${target.value}`,
        this.list,
      )
    }

    this.updateSubmitButton(validInputLength)
  }

  updateSubmitButton (valid) {
    if (valid) {
      this.submitButton.setAttribute('aria-disabled', false)
    } else {
      this.submitButton.setAttribute('aria-disabled', true)
    }
  }

  createHiddenInput (name, value, container) {
    const input = window.BAO.utils.createElement('input', {
      name: `properties[${name}]`,
      value,
      type: 'hidden',
    })
    container.appendChild(input)
  }
}

customElements.define('product-exclusive', ProductExclusive)
